import { JsonPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { ChatbotConfig, HistoryItemResponse, MessageItem } from '@shared/index';
import { BotMessagesService } from 'src/app/shared/services/bot-messages.service';
import { BotService } from 'src/app/shared/services/bot.service';

@Component({
  selector: 'app-message-mcp-approval-request',
  imports: [JsonPipe],
  templateUrl: './message-mcp-approval-request.html',
  styleUrl: './message-mcp-approval-request.scss'
})
export class MessageMcpApprovalRequest {
  public readonly message = input.required<HistoryItemResponse>();
  public readonly botConfig = input.required<ChatbotConfig>();
  public bot = inject(BotService);
  public botMessages = inject(BotMessagesService);

  protected blockButtons: boolean = false;

  public jsonParse(str: string): unknown {
    return JSON.parse(str) as unknown;
  }

  public capitalize(str: string) {
    return str.at(0)?.toUpperCase() + str.slice(1);
  }

  public async mcpApprovalResponse(approval: boolean) {
    this.blockButtons = true;
    const mcpApprovalRequest = this.message().content.at(0);
    if (mcpApprovalRequest?.type === "mcp_approval_request") {
      const response: MessageItem = {
        role: "mcp_approval_response",
        content: [
          {
            type: "mcp_approval_response",
            approve: approval,
            approval_request_id: mcpApprovalRequest.id
          }
        ]
      };
      await this.bot.mcpApprovalResponse(this.botConfig()._id, response, this.botMessages.getMessages());
      this.blockButtons = false;
    }
  }

  public messageApprovalDone(): boolean {
    return this.getApprovalResponse() != null;
  }

  public wasApproved(): boolean {
    const response = this.getApprovalResponse();
    if (response?.type !== "mcp_approval_response") return false;
    return response.approve;
  }

  private getApprovalResponse() {
    const mcpApprovalRequest = this.message().content.at(0);
    if (mcpApprovalRequest?.type !== "mcp_approval_request") return null;
    const responseMsg = this.botMessages.getMessages().find(m => {
      const mcpApprovalResponse = m.content.at(0);
      if (mcpApprovalResponse?.type !== "mcp_approval_response") return false;
      return mcpApprovalResponse.approval_request_id === mcpApprovalRequest.id;
    });
    return responseMsg?.content.at(0) ?? null;
  }
}
